
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";
import { useAppLayout } from "./AppLayout"; 
import { InvenioLogo } from "@/components/ui/invenio-logo";
import { ViewAsButton } from "@/components/ViewAsButton";
import { UserNav } from "./UserNav";
import { GlobalEnrichmentIndicator } from './GlobalEnrichmentIndicator';
import { ThemeToggle } from './ThemeToggle';
import { NotificationBell } from './NotificationBell';
import { useAuth } from "@/contexts/AuthContext";

export const Navbar = () => {
  const { toggleSidebar } = useAppLayout();
  const { isAuthenticated } = useAuth();

  return (
    <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 px-4">
      <div className="flex h-14 items-center justify-between"> 
        <div className="flex items-center space-x-2">
          {/* Mobile sidebar toggle */}
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleSidebar}
            className="md:hidden" 
            aria-label="Toggle sidebar"
          >
            <Menu className="h-5 w-5" />
          </Button>
          
          {/* Logo and App Name - Visible on all screen sizes */}
          <Link to={isAuthenticated ? "/dashboard" : "/"} className="flex items-center space-x-2">
            <InvenioLogo className="h-8 w-auto text-primary" />
            <span className="font-bold text-xl text-foreground hidden sm:inline-block">InvenioCRM</span>
          </Link>
        </div>

        <div className="flex items-center space-x-1 sm:space-x-2">
          <GlobalEnrichmentIndicator /> 
          <NotificationBell />
          <ThemeToggle />
          <ViewAsButton />
          <UserNav />
        </div>
      </div>
    </header>
  );
};
